export default "__VITE_ASSET__CWxznGLN__"